import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import useMobileBackButton from '../../hooks/useMobileBackButton';
import './UnifiedModal.css';

const UnifiedModal = ({
  show,
  onHide,
  title,
  children,
  footerButtons = [],
  footerExtra,
  dir,
  className = "fullscreen-modal",
  onEntered,
  bodyStyle,
  showFooter = true,
  customFooter,
  ...props
}) => {
  const { t } = useTranslation();
  const rtl = dir === 'rtl';

  useMobileBackButton(show, onHide);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dir={dir}
      className={className}
      style={rtl ? { textAlign: "right" } : {}}
      onEntered={onEntered}
      {...props}
    >
      <Modal.Header closeButton className={rtl ? 'text-right' : ''}>
        <Modal.Title className={rtl ? 'w-100 text-right' : ''}>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={rtl ? 'text-right' : ''} style={bodyStyle}>
        {children}
      </Modal.Body>
      {showFooter ? (
        <Modal.Footer className={rtl ? 'text-right' : ''}>
          {customFooter ? customFooter : (
            <>
              {footerButtons.map((btn, idx) => {
                const isDisabled = Boolean(btn.disabled || btn.loading);
                const buttonContent = btn.loading ? (
                  <>
                    <span className={`spinner-border spinner-border-sm ${rtl ? 'ml-2' : 'mr-2'}`} role="status" aria-hidden="true" />
                    {btn.children}
                  </>
                ) : btn.children;

                if (btn.href) {
                  return (
                    <a key={idx} href={btn.href} target={btn.target || '_self'} onClick={btn.onClick}>
                      <Button variant={btn.variant || 'secondary'} disabled={isDisabled} type={btn.type || 'button'}>
                        {buttonContent}
                      </Button>
                    </a>
                  );
                }
                return (
                  <Button
                    key={idx}
                    variant={btn.variant || 'secondary'}
                    onClick={btn.onClick}
                    disabled={isDisabled}
                    type={btn.type || 'button'}
                    className={btn.className}
                  >
                    {buttonContent}
                  </Button>
                );
              })}
              <Button variant="secondary" onClick={onHide}>
                {t('close')}
              </Button>
              {footerExtra}
            </>
          )}
        </Modal.Footer>
      ) : null}
      {!showFooter && customFooter ? customFooter : null}
    </Modal>
  );
};

export default UnifiedModal;